import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import { Card, Typography, Box, Button } from "@curves/ui-base";
import { CreditCardInfoSectionByRead, QuitSectionByRead, RenterSectionByRead, RentMainSectionByRead, TopSectionByRead } from "./components/DocumentComponents";
import useCabinetRentalApi from "@apis/useCabinetRentalApi";
import { CLUB_MEMBERS_ROUTER } from "@icoach/router/routerPath";
import RentCabinetDialogBox from "@icoach/rentCabinet/dialog/RentCabinetDialogBox";
import { cabinetPaymentCycleMap } from "@icoach/rentCabinet/staticData";
import { isEqual, mergeQueryToUrl } from "@util/utils";

const RentCabinetDocumentButtons = props => {
	const { sourceData, dialogRef, refresh } = props;
	const { isEditable, isQuitDeletable, canRenew, cabinetRentalID } = sourceData || {};
	const history = useHistory();

	const handleOnClick = url => {
		history.push(url);
	};

	// Allen TODO
	return (
		<Box className="btn-group">
			{isEditable && (
				<Button variant="outlined" onClick={() => handleOnClick(CLUB_MEMBERS_ROUTER.CABINET.GET_CONTRACT_RENTCABINETID_PATH("contract", cabinetRentalID))}>
					編輯租約
				</Button>
			)}
			{canRenew && (
				<Button
					variant="outlined"
					onClick={() => handleOnClick(mergeQueryToUrl(CLUB_MEMBERS_ROUTER.CABINET.GET_CONTRACT_RENTCABINETID_PATH("contract", 0), { renewCabinetRentalID: cabinetRentalID }))}
				>
					續約
				</Button>
			)}
			{isEditable && (
				<Button variant="outlined" onClick={() => dialogRef.current && dialogRef.current.openQuitRentCabinetDialog({ cabinetRentalID: cabinetRentalID }, refresh)}>
					退租申請
				</Button>
			)}
			{isQuitDeletable && (
				<Button variant="outlined" onClick={() => dialogRef.current && dialogRef.current.openDeleteQuitRentCabinetDialog({ cabinetRentalID: cabinetRentalID }, refresh)}>
					刪除退租申請
				</Button>
			)}
		</Box>
	);
};
// 租櫃申請書唯讀
const RentCabinetDocumentPageByRead = props => {
	const { rentCabinetID } = props.match.params;
	const { getRentCabinetApi } = useCabinetRentalApi();
	const [sourceData, setSourceData] = useState({});
	const { paymentCycle } = sourceData;
	const dialogRef = useRef(null);

	const doRentCabinetApi = async rentCabinetID => {
		let res = await getRentCabinetApi(rentCabinetID);
		if (res) {
			setSourceData(res);
		}
	};

	const refresh = () => doRentCabinetApi(rentCabinetID);

	useEffect(
		() => {
			if (!isEqual(rentCabinetID, 0)) {
				doRentCabinetApi(rentCabinetID);
			}
		},
		// eslint-disable-next-line
		[rentCabinetID],
	);

	return (
		<Box className="container main-container-spacing rent-cabinet-page">
			<Box component="header" className="page-header">
				<Typography className="page-header-title" variant="h3">
					置物櫃承租申請書
				</Typography>
				<RentCabinetDocumentButtons sourceData={sourceData} dialogRef={dialogRef} refresh={refresh} />
			</Box>
			<TopSectionByRead className="mb-4" sourceData={sourceData} />
			<Card className="order-info-card mb-4">
				<RenterSectionByRead sourceData={sourceData} />
				{isEqual(sourceData?.cabinetRentalStatus, 2) && <QuitSectionByRead titleClassName="bg-error-light" sourceData={sourceData} />}
				<RentMainSectionByRead sourceData={sourceData} />
				{isEqual(paymentCycle, cabinetPaymentCycleMap.monthly) && <CreditCardInfoSectionByRead sourceData={sourceData} />}
			</Card>
			<RentCabinetDialogBox ref={dialogRef} />
		</Box>
	);
};

export default RentCabinetDocumentPageByRead;
